import { render, staticRenderFns } from "./person-arrow-right.vue?vue&type=template&id=17fc6159&scoped=true&"
import script from "./person-arrow-right.vue?vue&type=script&lang=js&"
export * from "./person-arrow-right.vue?vue&type=script&lang=js&"
import style0 from "./person-arrow-right.vue?vue&type=style&index=0&id=17fc6159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc6159",
  null
  
)

export default component.exports